import type { ClassNames, ModifiersClassNames } from 'react-day-picker';

/**
 * Maps react-day-picker slot names to the registry's CSS class API.
 * Themes provide visual styling for each `.calendar-*` class.
 */
export const CALENDAR_CLASS_NAMES: Partial<ClassNames> = {
  months: 'calendar-months',
  month: 'calendar-month',
  month_caption: 'calendar-month-caption',
  month_grid: 'calendar-grid',
  weekdays: 'calendar-weekdays',
  weekday: 'calendar-weekday',
  week: 'calendar-week',
  day: 'calendar-day',
  day_button: 'calendar-day-button',
  disabled: 'calendar-day-disabled',
  hidden: 'calendar-day-hidden',
};

/**
 * Range-mode modifier classes. react-day-picker applies these to the parent
 * `<td>` element, so the `.calendar-range-*` classes target the cell.
 */
export const CALENDAR_RANGE_MODIFIERS_CLASS_NAMES: ModifiersClassNames = {
  range_start: 'calendar-range-start',
  range_middle: 'calendar-range-middle',
  range_end: 'calendar-range-end',
};
